import Vue from 'vue'
import VueRouter from "vue-router"
import Vuelidate from 'vuelidate'
import App from './App.vue'
Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.config.productionTip = false
const routes = [{path:'/:id(\\d+)', component:()=>import('@/components/inscripcion'), props: true}];
const router = new VueRouter({mode: 'history',routes})
require('@/assets/css/vendors.bundle.css');
require('@/assets/css/app.bundle.css');
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
